import { useEffect } from 'react';
import {
  useParams,
  useNavigate,
  generatePath,
  useMatch,
} from 'react-router-dom';
import { useAppSelector, useAppDispatch } from '@store';
import {
  useGetCreatePrimaryValidatorQuery,
  useLazyGetPrimaryAccountsQuery,
} from '../../store/services/primary-accounts';
import { clearPrimariesAccountsState } from '../../store/slices/primary-accounts';
import ROUTES from '../../../../routes';

const useList = () => {
  const navigate = useNavigate();
  const { categoryId, groupId, primaryAccountId } = useParams();

  const { accounts } = useAppSelector((state) => state.charts.accounts);

  const match = useMatch(ROUTES.PRIMARY_ACCOUNTS);
  const dispatch = useAppDispatch();

  useGetCreatePrimaryValidatorQuery();

  const [getPrimaryAccounts, { isLoading, isFetching }] =
    useLazyGetPrimaryAccountsQuery();

  useEffect(() => {
    dispatch(clearPrimariesAccountsState());

    if (groupId && groupId !== 'groupId') {
      getPrimaryAccounts(`all=true&groupId=${groupId}`);
    }
  }, [groupId, dispatch]);

  useEffect(() => {
    if (match && !isLoading && accounts) {
      navigate(
        generatePath(ROUTES.PRIMARY_ACCOUNTS, {
          categoryId: categoryId as string,
          groupId: groupId || 'groupId',
          primaryAccountId: accounts[0] ? accounts[0]?.id : 'primaryAccountId',
        }),
        { replace: true },
      );
    }
  }, [accounts, match, categoryId, groupId, isLoading, primaryAccountId]);

  return {
    categoryId,
    groupId,
    primaryAccountId,
    accounts,
    isFetching,
    isLoading,
  };
};

export default useList;
